import { render, staticRenderFns } from "./PDPCommentRatings.vue?vue&type=template&id=4f8d2e1a&scoped=true&"
import script from "./PDPCommentRatings.vue?vue&type=script&lang=js&"
export * from "./PDPCommentRatings.vue?vue&type=script&lang=js&"
import style0 from "./PDPCommentRatings.vue?vue&type=style&index=0&id=4f8d2e1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8d2e1a",
  null
  
)

export default component.exports